module.exports = __webpack_public_path__ + "static-portal/img/hrerp.e0dde77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hrerp.jpg
// module id = wPRL
// module chunks = 4